"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=networker.interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/networker/lib/networker.interfaces.js
// module id = 1199
// module chunks = 8